import { useEffect } from "react";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { getPlayStatus, loadPlay } from "../../store/play";
import { getCurrentGroup } from "../../store/groups";
import { useI18n } from "../../i18n/LanguageContext";

const PlayLoader = ({ children }) => {
  const dispatch = useDispatch();
  const { t } = useI18n();
  const playLoader = useSelector(getPlayStatus());
  const group = useSelector(getCurrentGroup());
  const playId = group?.playId || "";

  useEffect(() => {
    dispatch(loadPlay());
  }, [dispatch, playId]);

  if (!playLoader)
    return (
      <div className="w-full h-full">
        <p className="flex justify-center my-5">{t("loader.notPlayed")}</p>
      </div>
    );
  return children;
};

PlayLoader.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
};

export default PlayLoader;
